import { render, staticRenderFns } from "./ConsignmentTable.vue?vue&type=template&id=4bbc953e&"
import script from "./ConsignmentTable.vue?vue&type=script&lang=js&"
export * from "./ConsignmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports